






















































































































































































































































































































import { readUserProfile } from '@/store/main/getters';
import { dispatchGetStaffDashboardStatisticsByStaff } from '@/store/staff/actions';
import { readStaffDashboardStatistics, readStaffDashboardStatisticsByStaff } from '@/store/staff/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import LeadSettingsModal from '@/components/Team/Modals/LeadSettingsModal.vue';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
    LeadSettingsModal,
  },
})
export default class StaffStatsTable extends Vue {
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  public currentPeriod: any = ['today', 'Today'];
  public search = '';
  public currentPage = 1;
  public perPage = 6;
  public showConsultantSettingsModal: boolean = false;
  public consultantRating: number = 0;
  public consultantLimit: number = 0;
  public consultantId: number = 0;

  public showGiveAwayModal: boolean = false;
  public giveAwayConsultantID: number | null = null;
  public giveAwayUserID: number | null = null;
  public leadSettingsModal: boolean = false;
  public leadSettings: any = null;
  public groupIds: any = null;

  public loadingState = {
    list: false,
    submitSettings: false,
    submitBlock: false,
    submit: false,
  };

  public async mounted() {
    this.loadingState.list = true;
    this.currentPeriod = ['today', this.$t('Today')];
    await dispatchGetStaffDashboardStatisticsByStaff(this.$store, {group: this.groupIds});
    this.loadingState.list = false;
  }

  get dashboardStats() {
    return readStaffDashboardStatistics(this.$store);
  }

  public async handleChangePeriod(period) {
    this.currentPeriod = period;
    this.loadingState.list = true;
    await dispatchGetStaffDashboardStatisticsByStaff(this.$store, {period: period[0], group: this.groupIds});
    this.loadingState.list = false;
  }

  public async handleSearchUser() {
    this.loadingState.list = true;
    await dispatchGetStaffDashboardStatisticsByStaff(
      this.$store, {period: this.currentPeriod[0], search: this.search, group: this.groupIds},
    );
    this.loadingState.list = false;
  }

  public handleChangeGroup(value) {
    this.groupIds = value;
    this.handleSearchUser();
  }

  get staffList() {
    return readStaffDashboardStatisticsByStaff(this.$store);
  }

  public async handleViewAsUser(userId) {
    await this.$router.push('/dashboard');
    this.$router.push(`/staff-dashboard/view-as/${userId}`);
  }

  public handleOpenLeadSettingsForm(user) {
    this.leadSettings = user;
    this.leadSettingsModal = true;
  }

  public handleCloseLeadSettingsModal() {
    this.leadSettingsModal = false;
    this.leadSettings = null;
  }

  public handleLeadSettingsUpdated() {
    this.handleCloseLeadSettingsModal();
    dispatchGetStaffDashboardStatisticsByStaff(
      this.$store, {period: this.currentPeriod[0], search: this.search, group: this.groupIds},
    );
  }

  public handleOpenGiveAwayForm(userID) {
    this.showGiveAwayModal = true;
    this.giveAwayUserID = userID;
  }

  public resetGiveAwayForm() {
    this.showGiveAwayModal = false;
    this.giveAwayConsultantID = null;
    this.giveAwayUserID = null;
  }

  public async handleSubmitGiveAwayUser() {
    if (!this.giveAwayConsultantID || !this.giveAwayUserID || this.giveAwayConsultantID === this.giveAwayUserID) {
      // @ts-ignore
      this.showToast( this, this.$t('Please, select consultant'), 'error');
      return null;
    }
    this.loadingState.submit = true;
    try {
      const response = await api.submitManagerGiveAwayUser(
        // @ts-ignore
        this.$store.getters.token, {consultant_id: this.giveAwayConsultantID, user_id: this.giveAwayUserID},
      );
      await dispatchGetStaffDashboardStatisticsByStaff(
        this.$store, {period: this.currentPeriod[0], search: this.search, group: this.groupIds},
      );
      this.resetGiveAwayForm();
      // @ts-ignore
      this.showToast( this, this.$t('Operation successful'));
    } catch (e) {
      // @ts-ignore
      this.showToast( this, this.$t('Error'), 'error');
    }
    this.loadingState.submit = false;
  }

  public handleChangeConsultant(value) {
    // const newList: any = [];
    // for (const [key, val] of Object.entries(value)) {
    //   // @ts-ignore
    //   newList.push(val.id);
    // }
    this.giveAwayConsultantID = value;
  }

  public async handleBlockUnblockConsultant(userId, action) {
    this.loadingState.submitBlock = true;
    try {
      const response = await api.submitBlockUnblockConsultant(
        this.$store.getters.token, { user_id: userId, action},
      );
      await dispatchGetStaffDashboardStatisticsByStaff(
        this.$store, {period: this.currentPeriod[0], search: this.search, group: this.groupIds},
      );
      // @ts-ignore
      this.showToast(
        this,
        action === 'block' ?
        this.$t('Consultant blocked successfully') :
        this.$t('Consultant unblocked successfully'),
      );
    } catch (e) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.loadingState.submitBlock = false;
  }

  public async handleSaveConsultantSettings() {
    this.loadingState.submitSettings = true;
    try {
      const response = await api.submitConsultantSettings(
        this.$store.getters.token,
        { user_id: this.consultantId, limit: this.consultantLimit, rating: this.consultantRating},
      );
      await dispatchGetStaffDashboardStatisticsByStaff(
        this.$store, {period: this.currentPeriod[0], search: this.search, group: this.groupIds},
      );
      this.resetConsultantSettingsForm();
      // @ts-ignore
      this.showToast(this, this.$t('Consultant settings updated successfully'));
    } catch (e) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.loadingState.submitSettings = false;
  }

  public handleOpenConsultantSettings(user) {
    this.consultantRating = user.consultant_rating;
    this.consultantLimit = user.consultant_limit;
    this.consultantId = user.id;
    this.showConsultantSettingsModal = true;
  }

  public resetConsultantSettingsForm() {
    this.showConsultantSettingsModal = false;
    this.consultantRating = 0;
    this.consultantLimit = 0;
    this.consultantId = 0;
  }

  public convertTimeSpent(total) {
      const seconds = total > 0 ? Math.floor( (total) % 60 ) : '00';
      const minutes = total > 0 ? Math.floor( (total / 60) % 60 ) : '00';
      const hours = total > 0 ? Math.floor( (total / (60 * 60)) % 24 ) : '00';
      const days = total > 0 ? Math.floor( total / (60 * 60 * 24) ) : '00';
      return `${days}:${hours}:${minutes}:${seconds}`;
  }

  get staffFields() {
    return [
      {
        key: 'actions',
        label: '',
        class: 'width-1',
      },
      {
        key: 'user',
        label: this.$t('Consultant'),
        sortable: false,
      },
      {
        key: 'country',
        label: this.$t('Country'),
        sortable: true,
      },
      {
        key: 'tasks',
        label: this.$t('Tasks'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'new_users',
        label: this.$t('New users'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'time_spent',
        label: this.$t('Time spent'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
  }

  get available() {
    const groups = [
      'Руководители - Консультирование', 'Руководители - Партнерство',
      'Руководитель отдела консультантов', 'Админы',
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
      "Менеджер отдела консультирования",
      "Менеджер партнерского отдела",
    ];
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
